import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { HealthStatusCard } from "@/features/health/components/health-status-card";
import { PingForm } from "@/features/health/components/ping-form";

export const healthRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/health",
  component: HealthPage,
});

function HealthPage() {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <h1 className="text-3xl font-bold tracking-tight">Backend health</h1>
      <HealthStatusCard />
      <PingForm />
    </div>
  );
}
